import { render, staticRenderFns } from "./schoolClassEdit.vue?vue&type=template&id=2c6b4f11&scoped=true&"
import script from "./schoolClassEdit.vue?vue&type=script&lang=js&"
export * from "./schoolClassEdit.vue?vue&type=script&lang=js&"
import style0 from "./schoolClassEdit.vue?vue&type=style&index=0&id=2c6b4f11&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6b4f11",
  null
  
)

export default component.exports